"use client";

import { useState } from "react";

import Image from "next/image";

import { GetProductQueryResult } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

import { ProductImagesMobileThumbnails } from "./productImagesMobileThumbnails.component";

export const ProductImagesMobile = ({ product }: ProductImagesMobileProps) => {
  const [selectedImage, setSelectedImage] =
    useState<SelectedProductImage | null>(() => {
      const productImage = product?.images?.[0];
      if (!productImage) return null;
      return {
        url: urlFor(productImage.image).width(768).height(768).url(),
        alt: productImage.alt,
        videoUrl: productImage?.video?.asset?.url,
      };
    });

  const renderSpotlight = () => {
    if (!selectedImage) return null;
    if (selectedImage.videoUrl) {
      return (
        <video
          data-testid="product-images-mobile-spotlight-video"
          src={selectedImage.videoUrl}
          className="h-78 w-full object-contain"
          controls
          playsInline
          autoPlay
          muted
          title={
            product?.name ? `Product video: ${product.name}` : "Product video"
          }
        />
      );
    }
    return (
      <Image
        width={768}
        height={768}
        src={selectedImage.url || ""}
        loading="eager"
        alt={selectedImage.alt || ""}
        className="bg-greyscale-background h-full w-full rounded-2xl object-contain"
        data-testid="product-images-mobile-spotlight-image"
      />
    );
  };
  return (
    <section
      data-testid="product-images-mobile"
      className="flex flex-col gap-6 md:hidden">
      {renderSpotlight()}
      <ProductImagesMobileThumbnails
        product={product}
        setSelectedImage={setSelectedImage}
      />
    </section>
  );
};

export type ProductImagesMobileProps = {
  product: GetProductQueryResult;
};

type SelectedProductImage = {
  url: string;
  alt?: string | null;
  videoUrl?: string;
};
